
<template>
    <div class="home">
        <div class="content">
            <!-- <div class="total_title">
                <img class="label" src="../assets/total@2x.png" alt="">
                <span class="text" v-if="total">￥{{thousands(total)}}</span>
            </div> -->
            <div class="first_list">
                <div class="content_item">
                    <div class="table" style="width: 100%;height: 100%;">
                        <div class="column header">
                            <el-row class="el-row">
                                <el-col :span="4">
                                    <div class="label"><img class="jf" src="../assets/index@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="label"><img class="jf" src="../assets/name@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="label"><img class="jf" src="../assets/个人销售额@2x.png" alt=""></div>
                                </el-col>
                                <!-- <el-col :span="6">
                                    <div class="label"><img class="jf" src="../assets/grjf@2x.png" alt=""></div>
                                </el-col> -->
                            </el-row>
                        </div>
                        <div class="column_content">
                            <div class="column" v-for="(item) in tableData1" :key="item._id">
                                <el-row>
                                    <el-col :span="4">
                                        <div v-if="item.sort == 1"><img class="icongroup" src="../assets/one@2x.png" alt="">
                                        </div>
                                        <div v-if="item.sort == 2"><img class="icongroup" src="../assets/two@2x.png" alt="">
                                        </div>
                                        <div v-if="item.sort == 3"><img class="icongroup" src="../assets/three@2x.png"
                                                alt="">
                                        </div>
                                        <div v-if="item.sort > 3" class="label-value">{{ item.sort }}</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="label-value">{{ item.name }}</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="label-value integral">
                                            <span class="zs">{{thousands(item.value)}}</span>
                                            <!-- <span  class="residue" style="font-size: 18px;">{{ item.residue }}</span> -->
                                        </div>
                                    </el-col>
                                    <!-- <el-col :span="6">
                                        <div class="label-value integral"><span class="zs">{{ thousands(item.oneself_value) }}</span></div>
                                    </el-col> -->
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="list_right">
                <div class="content_item">
                    <div class="table" style="width: 100%;height: 100%">
                        <div class="column header">
                            <el-row class="el-row">
                                <el-col :span="4">
                                    <div class="label"><img class="jf" src="../assets/index@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="label"><img class="jf" src="../assets/name@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="label"><img class="jf" src="../assets/个人销售额@2x.png" alt=""></div>
                                </el-col>
                                <!-- <el-col :span="6">
                                    <div class="label"><img class="jf" src="../assets/grjf@2x.png" alt=""></div>
                                </el-col> -->
                            </el-row>
                        </div>
                        <div class="column_content">
                            <div class="column" v-for="(item, index) in tableData2" :key="index">
                                <el-row>
                                    <el-col :span="4">
                                        <div class="label-value">{{ item.sort }}</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="label-value">{{ item.name }}</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="label-value integral"><span class="zs">{{thousands(item.value)}}</span></div>
                                    </el-col>
                                    <!-- <el-col :span="6">
                                        <div class="label-value integral"><span class="zs">{{ thousands(item.oneself_value) }}</span></div>
                                    </el-col> -->
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="list_right">
                <div class="content_item">
                    <div class="table" style="width: 100%;height: 100%">
                        <div class="column header">
                            <el-row class="el-row">
                                <el-col :span="4">
                                    <div class="label"><img class="jf" src="../assets/index@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="5">
                                    <div class="label"><img class="jf" src="../assets/name@2x.png" alt=""></div>
                                </el-col>
                                <el-col :span="6">
                                    <div class="label"><img class="jf" src="../assets/个人销售额@2x.png" alt=""></div>
                                </el-col>
                                <!-- <el-col :span="6">
                                    <div class="label"><img class="jf" src="../assets/grjf@2x.png" alt=""></div>
                                </el-col> -->
                            </el-row>
                        </div>
                        <div class="column_content">
                            <div class="column" v-for="(item, index) in tableData3" :key="index">
                                <el-row>
                                    <el-col :span="4">
                                        <div class="label-value">{{ item.sort }}</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <div class="label-value">{{ item.name }}</div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="label-value integral"><span class="zs">{{ thousands(item.value) }}</span></div>
                                    </el-col>
                                    <!-- <el-col :span="6">
                                        <div class="label-value integral"><span class="zs">{{ thousands(item.oneself_value) }}</span></div>
                                    </el-col> -->
                                </el-row>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="scroll" ref="scroll" :class="messagelist.length > 0 ? 'backlinear' : ''">
                <div :class="{ 'mask': showmask }"></div>
                <div class="background flex space-between">
                    <ul id="ulll">
                        <li v-for="(item, index) in messagelist" :key="index" class="li">
                            <div class="elrow flex">
                                <div class="sculpture">
                                    <img class="sculpture-img" fit="cover" src="../assets/mesicon@2x.png" />
                                    <div class="username">{{ item.time }} </div>
                                </div>
                                <div class="single_line">
                                    {{ item.msg }}
                                </div>
                                <div class="disable"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
    name: 'Index',
    data() {
        return {
            tableData: [],
            tableData1: [],
            tableData2: [],
            tableData3: [],
            total:0,
            endTime:0,
            messagelist: [],
            showmask: false,
            arr: {
                one: [],
                two: []
            },
        }
    },
    computed:{
      topic(){
        const {id} = this.$route.query
        return id
      },
      screenData(){
        return `screenData${this.topic}`
      }
    },
    created() {
        this.newMqtt()
    },
    destroyed() {
        this.$mqtt.end()
    },
    methods: {
        newMqtt() {
            this.$mqtt.subscribe(this.screenData, { qos: 0 }, (err, granted) => {
                if (err) {
                    console.error(err)
                } else {
                    axios.get(`${this.$baseUrl}/report/public/screen/data/` + this.topic)
                    console.log('Subscribed to topic', granted[0].topic)
                }
            })
            this.$mqtt.on('message', (topic, message, packet) => {
                switch (topic) {
                    case this.screenData:
                        console.log(JSON.parse(message.toString()), 'tableData1')
                        const {total,data,time:endTime} = JSON.parse(message.toString())
                        this.total = total.toFixed(2)
                        this.tableData = data
                        this.tableData1 = data
                        this.endTime = endTime
                }
            })

            this.$mqtt.on('reconnect', (error) => {
                console.log('正在重连:', error)
                if (!error) {
                    axios.get(`${this.$baseUrl}/report/public/screen/data/` + this.topic)
                }
            })
            setTimeout(() => {
                this.list()
            }, 1000)
        },
        list() {
            var count = 1
            const sliceTableData=()=>{
              this.tableData2 = this.tableData.slice(10 * count)
              this.tableData3 = this.tableData.slice(10 * (count + 1))
              count += 2
            }
            sliceTableData()
            setInterval(() => {
                if (this.tableData < 10) return
                sliceTableData()
                const timeInterval = this.endTime - Date.now()
                if (this.tableData3.length <= 10 || timeInterval<=10*60*1000) {
                    count = 1
                }
            }, 10000);
        },
        thousands(number) {
            let arr = String(number).split('.');
            let num = arr[0];
            let len = Math.ceil(num.length / 3) * 3;
            let result = num.padStart(len, '0').match(/\d{3}/g).join(',').replace(/^0+/, '');
            return arr[1] ? result + '.' + arr[1] : result;
        },
    }
}
</script>

<style lang="scss">
html {
    font-size: 12px;
}

.flex {
    display: flex;
}

.home {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 15rem 5.83rem 12.5rem 5.83rem;
    background: url('../assets/celebrationBg.png') no-repeat;
    background-size: 100% 100%;

    .content {
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        height: 100%;
        width: 100%;
        position: relative;
        background: url('../assets/celebrationTable.png') no-repeat;
        background-size: 100% 100%;

        .total_title {
            display: flex;
            align-items: center;
            position: absolute;
            top: -6.75rem;
            left: 0;

            .label {
                width: 15.92rem;
                height: 5.5rem;
                margin-right: 2.5rem;
            }

            .text {
                font-size: 3.17rem;
                font-family: AlibabaPuHuiTiM;
                color: #000000;
                line-height: 4.33rem;
            }
        }

        .first_list {
            box-sizing: border-box;
            width: 32.5%;
            height: 100%;
            padding: 0.87% 0.95%;
            // margin-top: -3.0px;
            // align-items: center;
            display: flex;
            // justify-content: center;

            .content_item {
                width: 100%;
                padding: 0 0;

                .column {
                    height: 9.8%;

                    .icongroup {
                        width: 30px;
                        height: 30px;
                        margin-top: 2px;
                    }
                }

                //height: 280.0px;
            }

            .imgicon {
                width: 86.7px;
                height: 54.6px;
                font-size: 9.4px;
                font-family: AlibabaPuHuiTiM;
                color: #FFFFFF;
                line-height: 11.0px;
                position: absolute;
                top: 0;
                left: 0;

                img {
                    height: 100%;
                    width: 100%;
                }

                .total_txt {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 52.0px;
                    height: 33.1px;
                    font-size: 9.4px;
                    font-family: AlibabaPuHuiTiM;
                    color: #FFFFFF;
                    display: flex;
                    align-items: center;
                    text-align: center;

                    div {
                        transform: rotate(-20deg);
                        margin-left: -4px;
                        margin-top: -2px;
                    }
                }
            }
        }

        .list_right {
            box-sizing: border-box;
            width: 32.5%;
            height: 100%;
            padding: 0.87% 0.95%;
        }

        .content_item {
            width: 100%;
            height: 100%;
            padding: 0 0;

            .table {
                overflow: hidden;

                .title_first {
                    width: 100%;
                    text-align: center;
                }

                .column_content {
                    height: 87.3%;
                }

                .column {
                    width: 100%;
                    height: 9.8%;
                    // font-size: 24px;
                    text-align: center;

                    &.header {
                        height: 12.7%;

                        .el-row {
                            height: 100%;
                        }
                    }

                    .el-row {
                        display: flex;
                        justify-content: space-around;
                        height: 100%;
                        padding-right: 4%;
                        align-items: center;
                    }

                    .label {
                        height: 21px;

                        .xh,
                        .jf {
                            // width: 41px;
                            height: 21px;
                        }

                        .tzb {
                            // width: 102px;
                        }

                    }

                    .label-value {

                        font-size: 18px;
                        font-family: AlibabaPuHuiTiM;
                        // font-weight: 600;
                        color: #333333;

                        &.integral {
                            width: 100%;
                            text-align: center;
                        }

                    }
                }
            }

        }

        .scroll {
            position: fixed;
            bottom: 0;
            left: 0;
            /*几个高度要一致*/
            height: 50vh;
            width: 15.5%;
            // width: 100vw;
            font-family: SourceHanSansSC-Regular;
            font-weight: normal;
            font-stretch: normal;
            line-height: 0vw;
            letter-spacing: 0vw;
            color: #666666;
            overflow: hidden;
            z-index: 10000;
            padding-left: 10px;
            padding-bottom: 3%;
            box-sizing: border-box;
            border-radius: 10px;

            // border-top:10px solid linear-gradient(180deg, #FFECF1 0%, rgba(255,246,248,0) 100%);
            .mask {
                position: absolute;
                background: linear-gradient(180deg, #F0EEF1 0%, rgba(240, 238, 241, 0) 100%);
                top: 0;
                left: 0;
                border-radius: 10px;
                width: 100%;
                height: 15%;
                z-index: 10000;
            }

            .disable {
                display: none;
            }
        }

        .backlinear {
            // background: linear-gradient(180deg, #FFECF1 0%, rgba(255, 246, 248, 0) 100%);

        }

        .shedow {
            position: absolute;
            top: vh(-150);
            left: 0;
            height: vh(200);
            width: 100%;
            box-shadow: getRem(-100) 0px getRem(100) getRem(100) #F0EEF1;
            z-index: 100000;
            // background: linear-gradient(180deg, #F0EEF1 0%, rgba(240,238,241,0) 100%);
            // box-shadow:-10px 0px 10px 1px #000;
        }

        .anim {
            transition: all 0.5s;
            /*几个高度要一致*/
            margin-top: -40px;
        }

        #ulll {
            padding: 0 !important;
            width: 100%;
            // overflow-y: scroll;
            // scrollbar-width: none;
            // -ms-overflow-style: none !important;

            // &::-webkit-scrollbar {

            //     display: none;
            //     /* Chrome Safari */

            // }


            li {
                list-style: none;
                margin: 12px 0;
            }

        }

        .background {
            display: flex;
            flex-direction: column;
            justify-content: flex-end;
            align-items: flex-end;
            height: 100%;
        }

        .elrow {
            // width: 258px;
            width: fit-content;
            // height: 66px;
            background: rgb(0, 0, 0, .2);
            padding: 8px;
            box-sizing: border-box;
            border-radius: 10px;
            align-items: center;
            position: relative;
        }

        .single_line {
            line-height: 25px;
            font-size: 18px;
            color: #FFFFFF;
            // padding-left:10px;
            margin-left: 12px;
            // flex: 1;
            max-width: 100%;
            z-index: 1000;
            display: flex;
            align-items: center;
            overflow: hidden;
            text-overflow: ellipsis;
            // width: 100%;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
            word-break: break-all;
        }

        .sculpture {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-evenly;
            height: 50px;

            .sculpture-img {
                width: 17px;
                height: 17px;
                // margin-left:7.8px;
                border-radius: 50%
            }
        }

        .username {
            font-size: 11px;
            font-family: AlibabaPuHuiTiR;
            color: #FFFFFF;
            line-height: 16px;
        }

    }
}

::v-deep .el-table {
    .el-table__row {
        background: #F0EEF1;
    }

    .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell {
        background: #E5E9F0;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/celebration.vue